export const getThumbId       = (playerId) => `${playerId}-thumb`;
export const getProgressBarId = (playerId) => `${playerId}-progress`;
export const getCurrentDateId = (playerId) => `${playerId}-current-date`;
